module.exports = "/images/philipeDupuy.jpg?5b066f59aa2e845df81d8ad53696d156";